import { render, staticRenderFns } from "./Secure3D.vue?vue&type=template&id=c6755d8a&"
import script from "./Secure3D.vue?vue&type=script&lang=js&"
export * from "./Secure3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports